module.exports = __webpack_public_path__ + "img/features04-02.4147d58.png";